export default __webpack_public_path__ + "static/media/Bentonite Happy Cat Litter.4a4ef617.png";